import { useSyncExternalStore } from 'react';

/**
 * Cel przycisku „wstecz” w gornym pasku na telefonie. Ustawia go `PageHeader`
 * strony szczegolow, czyta `Topbar` (Dawid 2026-09-30: „jak wejde na oferte, jak
 * szybko wrocic do leada — znowu musze naciskac maly napisik”). Pasek jest
 * przyklejony, wiec powrot jest pod kciukiem takze po przewinieciu strony.
 */
export interface BackTarget {
  to: string;
  label: string;
}

let current: BackTarget | null = null;
const listeners = new Set<() => void>();

export function setMobileBack(target: BackTarget | null): void {
  current = target;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useMobileBack(): BackTarget | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => null,
  );
}
